import useHotkey from '../hooks/use-hotkey';
import { setHotkey } from '@form-engine/builder-application/keybindings';
import useMounted from '@form-engine/core-application/hooks/use-mounted';
import { useCallback } from 'react';
import { useFormContext } from '@form-engine/core-application/hooks/use-form';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { useImportForm } from '../../hub/hooks/import-form';
import Builder from '@form-engine/builder-application/index';

export default function useImportFormFileAction() {
    const { state: form, set } = useFormContext();
    const mounted = useMounted();
    const importForm = useImportForm();

    return useCallback(async () => {
        const toastId = toast(Builder.i18n.c('import-form.importing'), {
            autoClose: false,
        });

        let importedForm;

        try {
            importedForm = await importForm(false);
        } catch {
            importedForm = null;
        }

        if (!importedForm) {
            toast.dismiss(toastId);
            return;
        }

        if (!mounted) return;

        importedForm.id = form.id;

        set(importedForm);

        toast.update(toastId, {
            autoClose: 1500,
            render: (
                <>
                    <CheckCircleFill className="me-2" />{' '}
                    {Builder.i18n.c('import-form.success')}
                </>
            ),
        });
    }, [form, toast, set]);
}

export const ACTION_NAME = 'formEditor.form.importFile';

setHotkey(ACTION_NAME, 'ctrl+alt+i,meta+alt+i');

export const useAction = useImportFormFileAction;

export function useActionHotkey() {
    useHotkey(ACTION_NAME, useAction());
}
